import React, { useState } from 'react';

const stories = [
  {
    avatar: '/images/sarah-M.jpg',
    content: `Three photos, one AI attractiveness test, infinite possibilities. After running my selfies through the best AI attractiveness test available, I posted my highest-scoring shot and watched the magic happen. My Instagram followers exploded from 3K to 47K overnight – the growth was so dramatic that a verified K-pop idol slid into my DMs asking, 'What AI attractiveness test is this? I need this exact app!' Now I'm getting brand collaboration requests daily.`,
    name: 'Sarah M.',
    job: 'Content Creator',
  },
  {
    avatar: '/images/jessica-L.jpg',
    content: `When I teased my crush with my 9.2/10 result from the AI attractiveness test, I thought it was just playful banter. His response? 'If the AI says you're that stunning, I'm literally driving over right now.' Twelve hours later, he was on my doorstep – having driven 750 miles non-stop – with flowers in hand, confessing he couldn't wait another second after seeing my attractiveness test results. Six months later, we're engaged. This AI beauty test didn't just rate my looks; it changed my entire love life.`,
    name: 'Jessica L.',
    job: 'Marketing Professional',
  },
  {
    avatar: '/images/michael-R.jpg',
    content: `Before discovering this accurate AI attractiveness test, I was trapped in endless mirror-selfie anxiety loops, second-guessing every photo for hours. The comprehensive analysis changed everything – breaking down my face into precise metrics like smile index, skin clarity scores, and side-profile ratings eliminated all the guesswork. Now I confidently lead with my strongest features, pitch campaign ideas with data-backed confidence, and my personal beauty test archive has become my secret weapon for every professional photoshoot. My modeling bookings increased 300% since I started optimizing based on the AI insights.`,
    name: 'Michael R.',
    job: 'Professional Model',
  },
];

const UserStories: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const total = stories.length;

  const prev = () => setCurrent((prev) => (prev - 1 + total) % total);
  const next = () => setCurrent((prev) => (prev + 1) % total);

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 flex flex-col md:flex-row items-center md:items-start space-y-8 md:space-y-0 md:space-x-8" style={{ minHeight: '500px' }}>
      {/* 头像 */}
      <div className="flex-shrink-0 flex flex-col items-center w-full md:w-auto">
        <div className="w-24 h-24 md:w-28 md:h-28 rounded-full bg-gray-200 border-4 border-white overflow-hidden flex items-center justify-center shadow-lg mb-4 md:mb-0">
          <img src={stories[current].avatar} alt={stories[current].name} className="w-full h-full object-cover" />
        </div>
      </div>
      {/* 内容和控件 */}
      <div className="flex-grow flex flex-col justify-between w-full md:w-auto md:h-[420px]">
        <div className="flex flex-col items-center md:items-start" style={{ minHeight: '300px' }}>
          <p className="text-base md:text-lg text-gray-700 font-medium mb-6 italic text-center md:text-left">“{stories[current].content}”</p>
          <div className="mt-4 text-center md:text-left">
            <span className="font-bold text-gray-900">{stories[current].name}</span>
            <span className="ml-2 text-gray-500">- {stories[current].job}</span>
          </div>
        </div>
        <div className="flex flex-col items-center gap-6 mt-8">
          {/* 分页指示器 */}
          <div className="flex gap-2">
            {stories.map((_, idx) => (
              <span key={idx} className={`w-3 h-3 rounded-full ${idx === current ? 'bg-purple-500' : 'bg-gray-300'} inline-block`}></span>
            ))}
          </div>
          {/* 切换按钮 */}
          <div className="flex gap-4">
            <button onClick={prev} className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-2xl text-gray-500 hover:bg-gray-100 transition">
              &#8592;
            </button>
            <button onClick={next} className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-2xl text-gray-500 hover:bg-gray-100 transition">
              &#8594;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStories; 